import React from "react";
import { numberFormatters } from "common";
import "./areaCellRenderer.scss";
import { NumberFormatKind } from "common/types";
import { useWidgetCurrentDataScale } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
import { UserPreferencesUnitOfAreaEnum } from "components/modal/settings/unitOfArea";
export const AreaCellRenderer = (params) => {
    const currentDataScale = useWidgetCurrentDataScale(params.sectionId, params.widgetId);
    if (!params.value) {
        return React.createElement("span", null);
    }
    let { unit } = params.value;
    const value = params.value.value || params.value.area;
    if (unit.toUpperCase() === UserPreferencesUnitOfAreaEnum.SquareMeter.toUpperCase()) {
        unit = language.en.widgets.unitOfAreaAbbreviations.squareMeter;
    }
    if (unit.toUpperCase() === UserPreferencesUnitOfAreaEnum.SquareFoot.toUpperCase()) {
        unit = language.en.widgets.unitOfAreaAbbreviations.squareFoot;
    }
    if ((value || value === 0) && !isNaN(value) && unit) {
        if (unit !== language.en.widgets.unitOfAreaAbbreviations.other) {
            return React.createElement("span", { className: "areaCellRenderer" },
                numberFormatters(value, NumberFormatKind.default, { maximumFractionDigits: 1, minimumFractionDigits: 1 }, currentDataScale),
                " ",
                React.createElement("span", { className: "unit" }, unit));
        }
        return React.createElement("span", { className: "areaCellRenderer" }, numberFormatters(value, NumberFormatKind.default, { maximumFractionDigits: 1, minimumFractionDigits: 1 }, currentDataScale));
    }
    return React.createElement("span", null);
};
